<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button
  type="button"
  on:click={() => dispatch('click')}
  class="w-16 h-16 rounded-full bg-white flex items-center justify-center"
>
  <div class="w-14 h-14 rounded-full bg-site-red-2 border-2 border-black flex items-center justify-center">
    <span class="text-white text-sm font-bold">60</span>
  </div>
</button>
